import React from 'react'

import { TagComponent, Icon, Verified, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import SmartTooltip from 'Pods/ItemPage/Components/SmartTooltip'

import { getTagColor } from '../../Utils/getTagColor'
import { getTagTooltipText } from '../../Utils/getTagTooltip'

const BADGE_DISPLAY_NAMES = {
  'QUALITY VERIFIED': 'CGT STANDARD',
}

function PricingTag({ badge }) {
  const is3DPrintVerified = badge === '3D PRINT VERIFIED'
  const displayName = BADGE_DISPLAY_NAMES[badge] || badge

  return (
    <SmartTooltip
      content={getTagTooltipText(badge)}
      id={`tooltip-${badge.toLowerCase().replace(/\s+/g, '-')}`}
      delayHide={100}
      delayUpdate={100}
      disableMobileEvent
      autoPosition
    >
      <TagComponent
        key={badge}
        type="ghost"
        backColor={getTagColor(badge)}
        color={badge === 'QUALITY VERIFIED' ? 'primary' : undefined}
        className={classnames(is3DPrintVerified && 'pricing-tag--3d-print-verified')}
      >
        {is3DPrintVerified && (
          <Icon
            svgComponent={Verified}
            size="tiny"
            notSpaced
            className="pricing-tag__icon pricing-tag__icon--3d-print-verified"
          />
        )}
        {displayName}
      </TagComponent>
    </SmartTooltip>
  )
}

PricingTag.propTypes = {
  badge: string.isRequired,
}

export default PricingTag
